import React from 'react';
import styled from 'styled-components';

import { Button, color as colors } from '@workboard/wobo-ui';

import BreadcrumbsIcon from './Icon';

import { ITextProps } from '../../types/teams.types';

const BreadcrumbsLink = styled(Button)`
  color: ${colors('--gray-600')};
  margin: 0 5px;
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  text-decoration: none;
  column-gap: ${({ theme }) => theme.spacing(0.5)}px;
  padding: 0;
  border: none !important;

  svg {
    padding: 2px;
  }

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    color: ${colors('--gray-600')};
    text-decoration: underline;
  }
`;

const Link = ({ name, iconType, refSrc }: ITextProps): JSX.Element => {
  const backLanding = (): void => {
    if (refSrc === 'OLP') {
      window.location.href = `${wbConfig.baseUrl}/okrs`;
    } else {
      // @ts-ignore
      ajaxPageLoad(
        `${wbConfig.baseUrl}/team`,
        undefined,
        undefined,
        undefined,
        undefined,
      );
    }
  };

  return (
    <BreadcrumbsLink
      onClick={backLanding}
      variant="link"
      size="small"
      {...(name?.length > 50 && { title: name })}
    >
      <BreadcrumbsIcon type={iconType} />
      {name}
    </BreadcrumbsLink>
  );
};

export default Link;
